import {
  observable,
  action
} from 'mobx'
import { getToken, findDocFile, getRootFolder, findDocFolder, addDocFolder, upload, getUserInfo, createShare, updateShare, cancelShare, getExchangeToken } from '@/api/fwApi/docs';
import getStream from './getStream';
import md5 from 'crypto-js/md5';
import {isMacSsoNoIos} from 'Utils/device';
// import {isIOS, isMacSsoNoIos} from 'Utils/device';
import { isSafari } from 'Utils/browser-info';
import { store } from "../index";
export default class docs extends getStream {
  @observable docsToken = localStorage.getItem("token") || null;
  // @observable docsToken = null;
  @observable maxSize = null;
  @observable docsRootFolderId = null;
  @observable docsCurrentFolderId = null;
  @observable docsModalType = "save";
  @observable isSaveSuccess = true;
  @observable isSetListSuccess = false;
  @observable docsFileData = [];
  @observable filterDocsFileData = [];
  @observable docsFolderData = [];
  @observable withCredentials = true;
  @observable appKey = "8bCo6gni";
  // @observable appKey = process.env.NODE_ENV === "production" ? "8bCo6gni" : "uw8PbyY2";
  @observable showMacDocs = false;
  @observable macToDocPage = false;
  @observable isMacOrSafari = isMacSsoNoIos || isSafari;

  // 新增手机端docs参数 
  // 显示手机端云文档
  @observable showMobileDocs = false;
  @observable mobileDocsType = "view" // view - 打开云文档； save - 保存云文档
  @action getShowMobileDocs(showMobileDocs){
    this.showMobileDocs = showMobileDocs
  }
  @action getMobileDocsType(mobileDocsType){
    this.mobileDocsType = mobileDocsType
  }


  @action getCurrentFolderId(docsCurrentFolderId){
    this.docsCurrentFolderId = docsCurrentFolderId
  }
  @action getIsSaveSuccess(isSaveSuccess){
    this.isSaveSuccess = isSaveSuccess
  }
  @action getDocsToken(docsToken){
    this.docsToken = docsToken
    // this.docsToken = ""
  }
  @action getIsSetListSuccess(isSetListSuccess){
    this.isSetListSuccess = isSetListSuccess
  }
  @action getDocsFileData(docsFileData){
    this.docsFileData = docsFileData
  }
  @action getFilterDocsFileData(filterDocsFileData){
    this.filterDocsFileData = filterDocsFileData
  }
  @action getDocsFolderData(docsFolderData){
    this.docsFolderData = docsFolderData
  }
  @action getDocsModalType(docsModalType){
    this.docsModalType = docsModalType
  }
  /**
   * [获取token]
   */
  @action getToken() {
    // if(isIOS) { // mac下一样获取token
    //   return
    // }
    let fid = window.readerCookies.fid
    this.withCredentials = this.isMacOrSafari ? 'no' : '';
    let params = {}
    if(!store.loginNewStore.IAMToken && fid) {
      params = {fid}
    }
    return new Promise((resolve, reject)=>{
      if(store.loginNewStore.IAMToken) {
        localStorage.setItem('token', store.loginNewStore.IAMToken);
        this.docsToken = store.loginNewStore.IAMToken;
        return resolve({code: 0});
      }
      getToken(params).then(res=>{
        this.withCredentials = ""
        if(res.code === 0){
          localStorage.setItem('token', res.data.token);
          this.docsToken = res.data.token;
        }
        resolve(res);
      },err=>{
        this.withCredentials = ""
        reject(err)
      })
    })
  }
  /**
   * [获取token]
   */
  
  /**
   * [登入后获取token，用于ios无法获取fid]
   */
   @action getExchangeToken() {
    const config = {
      headers: {
        appKey:this.appKey
      }
    };
    return new Promise((resolve, reject)=>{
      getUserInfo(config).then(resAll=>{
        if(resAll.code === 0){
          getExchangeToken(config).then(res=>{
            if(res.code === 0) {
              localStorage.setItem('token', res.data.token);
              this.docsToken = res.data.token;
            }
            resolve(res);
          },err=>{
            reject(err)
          })
        }
      }).catch(err => {
        console.log(err)
      })
    })
  }
  /**
   * [获取根目录id]
   */
  @action getRootFolder() {
    this.withCredentials = this.isMacOrSafari ? 'no' : '';
    const config = {
      headers:{
        token:this.docsToken,
        appKey:this.appKey
      }
    }
    if(store.loginNewStore.IAMToken) {
      delete config.headers.token
    }
    return new Promise((resolve, reject)=>{
      getRootFolder(config).then(res=>{
        this.withCredentials = "";
        if(res.code === 0){
          this.docsRootFolderId = res.data.folderId;
          this.docsCurrentFolderId = res.data.folderId;
        }
        resolve(res);
      },err=>{
        this.withCredentials = "";
        reject(err)
      })
    })
  }
  /**
   * 获取文件
   * @param {*} page 页数
   * @param {*} folderName 每页数量
   * @returns 
   */
  @action getFindDocFile(folderId, page=1, limit=10) {
    this.withCredentials = this.isMacOrSafari ? 'no' : '';
    const config = {
      params:{
        folderId,
        page,
        limit
      },
      headers:{
        token:this.docsToken,
        appKey:this.appKey
      }
    }
    if(store.loginNewStore.IAMToken) {
      delete config.headers.token
    }
    return new Promise((resolve, reject)=>{
      findDocFile(config).then(res=>{
        this.withCredentials = '';
        resolve(res);
      },err=>{
        this.withCredentials = '';
        reject(err)
      })
    })
  }
  /**
   * 获取文件夹
   * @param {*} parentId 父级目录id
   * @returns 
   */
  @action getFindDocFolder(folderId) {
    this.withCredentials = this.isMacOrSafari ? 'no' : '';
    const config = {
      params:{
        folderId
      },
      headers:{
        token:this.docsToken,
        appKey:this.appKey
      }
    }
    if(store.loginNewStore.IAMToken) {
      delete config.headers.token
    }
    return new Promise((resolve, reject)=>{
      findDocFolder(config).then(res=>{
        this.withCredentials = '';
        resolve(res);
      },err=>{
        this.withCredentials = '';
        reject(err)
      })
    })
  }
  /**
   * 创建文件夹
   * @param {*} parentId 父级目录id
   * @param {*} folderName 文件名
   * @returns 
   */
  @action addDocFolder(parentId, folderName) {
    this.withCredentials = this.isMacOrSafari ? 'no' : '';
    const config = {
      params:{
        parentId,
        folderName
      },
      headers:{
        token:this.docsToken,
        appKey:this.appKey
      }
    }
    if(store.loginNewStore.IAMToken) {
      delete config.headers.token
    }
    return new Promise((resolve, reject)=>{
      addDocFolder(config).then(res=>{
        this.withCredentials = '';
        resolve(res);
      },err=>{
        this.withCredentials = '';
        reject(err)
      })
    })
  }
  /**
   * 获取当前文件文件流
   * @returns 
   */
  @action fileToBlob(fileName, folderId, isFree = false) {
    return new Promise((resolve, reject)=>{
      this.getFileBlob().then(blob => {
        this.uploadDocument(blob, fileName, folderId, isFree).then(res=>{
          resolve(res)
        },err=>{
          reject(err)
        });
      });
    })
  }
  /**
   * 上传文件
   * @param {*} blob 文件流
   * @param {*} fileName 文件名
   * @param {*} folderId 目录id
   * @returns 
   */
  @action uploadDocument(blob, fileName="default.pdf", folderId, isFree=false) {
    let formData = new FormData();
    formData.append("file", blob, fileName);
    formData.append("fileName", fileName);
    formData.append("folderId", folderId);
    formData.append("md5", md5(blob));
    formData.append("isFree", isFree);
    if(!store.loginNewStore.IAMToken) {
      formData.append("token", this.docsToken);
    }
    this.withCredentials = this.isMacOrSafari ? 'no' : '';
    const config = {
      headers: {
        "Content-Type": "multipart/form-data;boundary = " + new Date().getTime(),
        token:this.docsToken,
        appKey:this.appKey
      },
      params: formData,
      timeout:1000000
    };
    if(store.loginNewStore.IAMToken) {
      delete config.headers.token
    }
    return new Promise((resolve, reject)=>{
      upload(config).then(res=>{
        this.withCredentials = '';
        resolve(res);
      },err=>{
        this.withCredentials = '';
        reject(err)
      })
    })
  }
  /**
   * [获取 userInfo]
   */
  @action async getUserInfo() {
    // 先去获取token 
    await this.getToken()
    this.withCredentials = this.isMacOrSafari ? 'no' : '';
    return new Promise((resolve, reject)=>{
      const config = {
        headers: {
          token:this.docsToken,
          appKey:this.appKey
        }
      };
      if(store.loginNewStore.IAMToken) {
        delete config.headers.token
      }
      getUserInfo(config).then(res=>{
        if(res.code === 0) {
          this.maxSize = res.data.maxSize;
        } else if (this.isMacOrSafari && res.code === 401) {
          this.withCredentials = true;
          window.open('https://docs.foxitcloud.cn/');
        }
        this.withCredentials = true
        resolve(res);
      },err=>{
        this.withCredentials = true
        reject(err)
      })
    })
  }
  /**
   * 创建分享
   * @param {*} docId 文档ID
   * @param {*} isEncrypted 是否加密
   * @param {*} activeDays 有效天数
   * @param {*} owner 分享者
   * @param {*} avatar 分享者头像
   * @returns 
   */
   @action createShare(params) {
    this.withCredentials = this.isMacOrSafari ? 'no' : '';
    const config = {
      params,
      headers:{
        token:this.docsToken,
        appKey:this.appKey
      }
    }
    if(store.loginNewStore.IAMToken) {
      delete config.headers.token
    }
    return new Promise((resolve, reject)=>{
      createShare(config).then(res=>{
        this.withCredentials = '';
        resolve(res);
      },err=>{
        this.withCredentials = '';
        reject(err)
      })
    })
  }
  /**
   * 修改分享信息
   * @param {*} shareId 分享ID
   * @param {*} isEncrypted 是否加密
   * @param {*} activeDays 有效天数 false
   * @param {*} drawCode 提取码(加密) false
   * @returns 
   */
   @action updateShare(params) {
    this.withCredentials = this.isMacOrSafari ? 'no' : '';
    const config = {
      params: params,
      headers:{
        token:this.docsToken,
        appKey:this.appKey
      }
    }
    if(store.loginNewStore.IAMToken) {
      delete config.headers.token
    }
    return new Promise((resolve, reject)=>{
      updateShare(config).then(res=>{
        this.withCredentials = '';
        resolve(res);
      },err=>{
        this.withCredentials = '';
        reject(err)
      })
    })
  }
  /**
   * 删除分享
   * @param {*} shareId 分享ID
   * @returns 
   */
   @action cancelShare(shareId) {
    this.withCredentials = this.isMacOrSafari ? 'no' : '';
    const config = {
      params: { shareId },
      headers:{
        token:this.docsToken,
        appKey:this.appKey
      }
    }
    if(store.loginNewStore.IAMToken) {
      delete config.headers.token
    }
    return new Promise((resolve, reject)=>{
      cancelShare(config).then(res=>{
        this.withCredentials = '';
        resolve(res);
      },err=>{
        this.withCredentials = '';
        reject(err)
      })
    })
  }
  // !以下为部分旧cmis功能迁移，用于保存的loading、弹窗、重命名和空间判断
  @observable isShowNoVipSpaceDialog = false
  @observable isShowVipSpaceDialog = false
  @observable isShowMoreSpaceDialog = false
  /**
   * [lackOfSpace 空间不足弹框]
   *
   * @return  {[type]}  [return description]
   */
   @action lackOfSpace() {
    this.setIsShowMeeting(true) // 显示loading
    const { isBusinessUser } = store.userNewStore
    if (isBusinessUser) {
      store.docsStore.getUserInfo().then(res => {
        console.log(res)
        if (res.data.maxSize / 1024 / 1024 >= 10240) {
          this.isShowMoreSpaceDialog = true
        } else {
          this.isShowVipSpaceDialog = true
        }
      })
    } else {
      this.setIsShowMeeting(false) // 显示loading
      this.isShowNoVipSpaceDialog = true
    }
  }
  // !文件重命名时间戳获取
  @action formatCompleteTime = date => {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();
    return (
      [year, month, day].map(this.formatNumber).join("") +
      "" +
      [hour, minute, second].map(this.formatNumber).join("")
    );
  };
  // !时间转换
  @action formatNumber(n) {
    let i = n.toString();
    return i[1] ? i : "0" + i;
  }
}
